import { Box ,Image} from '@chakra-ui/react'
import React from 'react'

export default function OnlineListing() {
  return (
    <Box>
        <Image src="https://assets.website-files.com/5d55f1425cb6b7a18aa77528/60ad55d0cf2e6bf5f160cdb6_rentals.png"/>
    </Box>
  )
}
